import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { take } from 'rxjs/operators';
import { AttendanceAdministrationService } from '../../admin360/attendance-administration/attendance-administration.service';
import { CheckInOutSubmissionRequest } from '../../student360/student-summary/check-in-out-submission-request-modal/check-in-out-submission-request-modal.model';
import { TylerMatTableDataSource } from '../angular-material/extended.class';
import { GeneralConfirmationComponent } from '../controls/general-confirmation/general-confirmation.component';
import { SharedService } from '../shared.service';
import { Student } from '../student/student.model';
import { UserService } from '../user/user.service';
import { ViewAttachmentsComponent } from '../view-attachments/view-attachments.component';

@Component({
  selector: 'app-self-check-in-out-history-dialog',
  templateUrl: './self-check-in-out-history-dialog.component.html',
  styleUrls: ['./self-check-in-out-history-dialog.component.css']
})
export class SelfCheckInOutHistoryDialogComponent implements OnInit {
  studentId: number;
  calledFromMenu = false;
  isStaff = false;
  selfCheckInOutSubmission: CheckInOutSubmissionRequest[] = [];

  columnsToDisplay = ['Type', 'Date', 'Time', 'Status', 'SubmittedBy', 'Reason', 'Attachment', 'Action'];
  angularMatData = new TylerMatTableDataSource(this.selfCheckInOutSubmission);

  _sort: MatSort;
  useStudents: Student[] = [];

  constructor(private dialogRef: MatDialogRef<SelfCheckInOutHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private attendanceAdminService: AttendanceAdministrationService,
    private userService: UserService,
    private sharedService: SharedService) {
      this.useStudents.push(this.data.selectedStudent);
     }

  @ViewChild(MatSort) set sort(value: MatSort) {
    this._sort = value;
    this.angularMatData.sort = value;
  }

  get sort(): MatSort {
    return this._sort;
  }

  ngOnInit() {
    this.studentId = this.data.studentId;
    this.isStaff = this.userService.currentUser.UserType == 1 ? true : false;
    if (this.data.calledFromMenu != undefined) {
      this.calledFromMenu = this.data.calledFromMenu;
    }
    if (this.calledFromMenu == false) {
      this.columnsToDisplay = ['Type', 'Date', 'Time', 'Status', 'Attachment', 'Reason'];
    }
    this.getSelfCheckInOutSubmissionHistory();
  }

  getSelfCheckInOutSubmissionHistory() {
    this.attendanceAdminService.getAttendanceSelfCheckInOutByStudentId(this.studentId).pipe(take(1)).subscribe(history => {
      this.selfCheckInOutSubmission = history;
      this.angularMatData.data = this.selfCheckInOutSubmission;
    });
  }

  cancelClick() {
    this.dialogRef.close();
  }

  viwAttachments(id: number) {
    this.attendanceAdminService.getCheckInOutHistoryAttachmentById(id, 'Submission').pipe(take(1)).subscribe(attachment => {
      this.dialog.open(ViewAttachmentsComponent, {
        data: {
          attachments: attachment
        },
        disableClose: true,
        minWidth: '750px'
    });
    });
  }

  deleteClick(recordId: number) {
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'Delete Check In/Out Record';
    deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete this Check In/Check Out Record?';
    deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
    deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
      if (deleteObject) {
        this.attendanceAdminService.deleteCheckInOutRecordById(recordId, 'submission').pipe(take(1)).subscribe(result => {
          if (result == true) {
            this.getSelfCheckInOutSubmissionHistory();
          }
          else {
            this.sharedService.showBadSnackbar();
          }
        });
      }
    });
  }

}
